import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EDocument, EDocumentsCategory, EDocumentsMedia } from '@qvs/core';
import {
  createLoadingStatusActionGroupWithParameter,
  createLoadingStatusActionGroupWithResponse
} from '~/shared/helpers/loading-status-helper';

const source = 'E-Documents';
const prefix = `[${source}]`;

export const {
  loadEDocumentsMediaAsJson,
  loadEDocumentsMediaAsJsonSuccess,
  loadEDocumentsMediaAsJsonFailure,
  upsertEDocuments,
  openPdfFailure,
  setEDocumentsCurrentBeginDate,
  loadAllEDocumentsSuccess,
  loadEDocumentsFirstBatchSuccess,
  loadEDocumentsFirstBatchFailure,
  resetEDocumentsState,
  loadAllEDocuments
} = createActionGroup({
  source,
  events: {
    'load e Documents Media As Json': props<{ documentId: string }>(),
    'load e Documents Media As Json success': props<{ documentId: string; eDocumentsMedia: EDocumentsMedia }>(),
    'load e Documents Media As Json failure': emptyProps(),
    'upsert e Documents': props<{ entities: EDocument[] }>(),
    'open Pdf Failure': props<{ error: unknown }>(),
    'set e documents current begin date': props<{ currentBeginDate: string }>(),
    'load all e documents success': emptyProps(),
    'load e documents first batch success': emptyProps(),
    'load e documents first batch failure': emptyProps(),
    'reset e documents state': emptyProps(),
    'load all e documents': emptyProps()
  }
});

export const {
  load: loadEDocumentsInBatches,
  success: loadEDocumentsInBatchesSuccess,
  failure: loadEDocumentsInBatchesFailure
} = createLoadingStatusActionGroupWithParameter<{ isFirstBatch?: boolean }>(prefix, 'e-documents');

export const {
  load: loadEDocumentsCategories,
  success: loadEDocumentsCategoriesSuccess,
  failure: loadEDocumentsCategoriesFailure
} = createLoadingStatusActionGroupWithResponse<{ eDocumentsCategories: EDocumentsCategory[] }>(prefix, 'e-document categories');
